// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

if (!i18n.isInitialized) {
  i18n
    .use(HttpBackend) // Use HTTP backend to load translations
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
      backend: {
        loadPath: "/locales/{{lng}}/translation.json", // Path to translation files in the public folder
      },
      lng: "fr", // Default language
      fallbackLng: "fr", // Fallback language
      debug: true, // Enable debug mode for logging
      interpolation: {
        escapeValue: false, // React already escapes values
      },
    });
}

export default i18n;